import {
  CSpinner,
  CTable,
  CTableHead,
  CTableBody,
  CTableRow,
  CTableHeaderCell,
  CTableDataCell,
} from '@coreui/react'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getOrderHistory } from 'src/redux/orders'

const OrdersHistory = () => {
  const dispatch = useDispatch()
  const { orderHistory, loading, error } = useSelector((state) => state.orders)

  useEffect(() => {
    dispatch(getOrderHistory())
  }, [dispatch])

  console.log('Order History Data:', orderHistory) // Debugging

  if (loading) return <CSpinner color="primary" className="d-block mx-auto my-4" />
  if (error) return <p className="text-danger text-center">Error: {error}</p>
  if (!Array.isArray(orderHistory) || orderHistory.length === 0)
    return <p className="text-center">No orders found</p>

  return (
    <CTable striped hover responsive>
      <CTableHead color="dark">
        <CTableRow>
          <CTableHeaderCell>#</CTableHeaderCell>
          <CTableHeaderCell>Order No</CTableHeaderCell>
          <CTableHeaderCell>Customer Name</CTableHeaderCell>
          <CTableHeaderCell>Mobile No</CTableHeaderCell>
          <CTableHeaderCell>Status</CTableHeaderCell>
          <CTableHeaderCell>Amount</CTableHeaderCell>
          <CTableHeaderCell>Delivery Charges</CTableHeaderCell>
          <CTableHeaderCell>Payment Method</CTableHeaderCell>
          <CTableHeaderCell>Billing Address</CTableHeaderCell>
          <CTableHeaderCell>Order Date</CTableHeaderCell>
        </CTableRow>
      </CTableHead>
      <CTableBody>
        {orderHistory.map((order, index) => (
          <CTableRow key={order.id}>
            <CTableDataCell>{index + 1}</CTableDataCell>
            <CTableDataCell>{order.order_no}</CTableDataCell>
            <CTableDataCell>{order.name}</CTableDataCell>
            <CTableDataCell>{order.mobile_no}</CTableDataCell>
            <CTableDataCell>
              <span
                className={`badge ${order.status === 'cancelled' ? 'bg-danger' : 'bg-success'}`}
              >
                {order.status}
              </span>
            </CTableDataCell>
            <CTableDataCell>₹{order.total_amount}</CTableDataCell>
            <CTableDataCell>₹{order.delivery_charges}</CTableDataCell>
            <CTableDataCell>{order.payment_method}</CTableDataCell>
            <CTableDataCell>{order.billing_address}</CTableDataCell>
            <CTableDataCell>{new Date(order.order_date).toLocaleDateString()}</CTableDataCell>
          </CTableRow>
        ))}
      </CTableBody>
    </CTable>
  )
}

export default OrdersHistory
